import { Pipe, PipeTransform } from '@angular/core';
import { BannerAction } from '../interfaces/interfaces';

@Pipe({
    name: 'banneraction'
})
export class BannerActionPipe implements PipeTransform {
    transform(input: BannerAction): string {
        switch (input) {
            case BannerAction.NOCLICK: return 'Nem kattintható';
            case BannerAction.URL: return 'Adott linkre mutat';
        }
        return '-';
    }
}